import { ApplicationAccessKey } from './../../../../../common/models/application.interface';
import { Component } from '@angular/core';

@Component({
    selector: 'app-header-bare',
    templateUrl: './header-bare.component.html',
    styleUrls: ['./header-bare.component.scss']
})
export class HeaderBareComponent {
    app: string;
    isSplashHeader: boolean;
    constructor() {
        this.app = ApplicationAccessKey.MERCHANDISING;
        this.isSplashHeader = true;
    }
}
